import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=68abf4b4&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=ts&"
export * from "./Contracts.vue?vue&type=script&lang=ts&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=68abf4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68abf4b4",
  null
  
)

export default component.exports